import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { IBookingRating } from '../interfaces/interface';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private http = inject(HttpClient);
  //сaseToken
  private caseToken: string | null = null;

  setCaseToken(token: string): void {
    this.caseToken = token;
  }

  getCaseToken(): string | null {
    return this.caseToken;
  }

  url = `${environment.apiBase}valid/${this.caseToken}`;

  getCaseStatus(token: string): Observable<any> {
    return this.http.get<any>(`${environment.apiBase}valid/${token}`);
  }

  submitFeedback(token: string, data: IBookingRating): Observable<any> {
    return this.http.post(`${environment.apiBase}feedback/${token}`, data);
  }
}
